import { useNavigate, useParams } from 'react-router-dom'

import { Button } from '@factorialco/deprecated-design-system'

import PopoverMenu from 'modules/core/components/PopoverMenu'
import { useNavigation } from 'modules/core/hooks/useNavigation'
import { track, trackingEvents } from 'modules/core/lib/Tracking'
import i18n from 'modules/core/lib/i18n'

interface SubprojectPopoverMenuListProps {
  subprojectId: number
  subprojectName: string
}

const SubprojectPopoverMenuList = ({
  subprojectId,
  subprojectName,
}: SubprojectPopoverMenuListProps) => {
  const { navigation } = useNavigation()
  const navigate = useNavigate()
  const { id } = useParams()

  return (
    <PopoverMenu type="list">
      <PopoverMenu.Trigger>
        <Button.Decorative
          type="secondary"
          aria-label="Subproject popover menu button"
          iconName="ellipsis"
        />
      </PopoverMenu.Trigger>
      <PopoverMenu.Content side="bottom" align="end">
        <PopoverMenu.TouchableOption
          title={i18n.t('project_management.table.subprojects_list.menu_links.edit_name')}
          onClick={() => {
            navigate(
              navigation.projects.id.details.subprojects.subprojectId.edit.fullPath({
                id: Number(id),
                subprojectId: subprojectId,
              }),
              { state: { subprojectName } }
            )
            track(trackingEvents.projectManagement.subprojects.editSubprojectStart, {
              project_id: id,
            })
          }}
        />
        <PopoverMenu.TouchableOption
          title={i18n.t('project_management.table.subprojects_list.menu_links.delete_subproject')}
          onClick={() => {
            navigate(
              navigation.projects.id.details.subprojects.subprojectId.delete.fullPath({
                id: Number(id),
                subprojectId: subprojectId,
              }),
              { state: { subprojectName } }
            )
            track(trackingEvents.projectManagement.subprojects.deleteSubprojectStart, {
              project_id: id,
            })
          }}
        />
      </PopoverMenu.Content>
    </PopoverMenu>
  )
}

export default SubprojectPopoverMenuList
